import { render, staticRenderFns } from "./CounterDetails.vue?vue&type=template&id=f6f759ae&"
import script from "./CounterDetails.vue?vue&type=script&lang=js&"
export * from "./CounterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports